import { useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Menu, X, UserRound, LayoutDashboard } from "lucide-react";
import { Logo } from "./Logo";
import { useAuth } from "./auth";

const NAV = [
  { to: "/", label: "Home" },
  { to: "/courses", label: "Courses" },
  { to: "/packages", label: "Packages" },
  { to: "/instructors", label: "Instructors" },
  { to: "/contact", label: "Contact" },
];

const AuthButton = ({ mobile, onClick }) => {
  const { user } = useAuth();
  const to = user ? (user.role === "admin" ? "/admin" : "/dashboard") : "/login";
  return (
    <Link to={to} onClick={onClick} data-testid={mobile ? "mobile-auth-btn" : "header-auth-btn"}
      className={`btn-neon text-sm !py-2.5 !px-5 ${mobile ? "justify-center" : "hidden sm:inline-flex"}`}>
      {user ? <><LayoutDashboard size={16} /> {user.role === "admin" ? "Admin Panel" : "My Dashboard"}</> : <><UserRound size={16} /> Login / Sign Up</>}
    </Link>
  );
};

const linkCls = ({ isActive }) =>
  `text-sm font-semibold transition-colors hover:text-[var(--pink)] ${isActive ? "text-[var(--pink)]" : "text-[var(--ink)]"}`;

export default function Header() {
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();
  if (pathname.startsWith("/admin") || pathname.startsWith("/dashboard")) return null;
  return (
    <header className="sticky top-0 z-40">
      <div className="glass !rounded-none !border-x-0 !border-t-0 w-full">
      <div className="max-w-7xl mx-auto flex items-center justify-between px-5 sm:px-8 py-3">
        <Link to="/" data-testid="header-logo" className="flex items-center gap-2">
          <Logo className="h-11 sm:h-14" />
        </Link>
        <nav className="hidden lg:flex items-center gap-8">
          {NAV.map((n) => (
            <NavLink key={n.to} to={n.to} end className={linkCls} data-testid={`nav-${n.label.toLowerCase()}`}>{n.label}</NavLink>
          ))}
        </nav>
        <div className="flex items-center gap-2">
          <AuthButton />
          <button data-testid="mobile-menu-btn" onClick={() => setOpen(!open)} className="lg:hidden glass w-10 h-10 grid place-items-center rounded-full">
            {open ? <X size={18} /> : <Menu size={18} />}
          </button>
        </div>
      </div>
      </div>
      {open && (
        <nav data-testid="mobile-menu" className="glass lg:hidden mx-4 mt-2 rounded-3xl p-5 flex flex-col gap-4">
          {NAV.map((n) => (
            <NavLink key={n.to} to={n.to} end className={linkCls} onClick={() => setOpen(false)}>{n.label}</NavLink>
          ))}
          <AuthButton mobile onClick={() => setOpen(false)} />
        </nav>
      )}
    </header>
  );
}
